var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOurMission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_4471)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.8793 30.52L24.8793 17.8533C24.6927 17.52 24.3993 17.36 23.986 17.3333C23.6127 17.3333 23.2793 17.5466 23.106 17.88L21.9727 20.0933L27.2793 29.5333C27.706 30.28 27.7727 31.1866 27.4793 32H30.9993C31.3593 32 31.6793 31.8133 31.866 31.5066C32.0393 31.2 32.0393 30.8266 31.8793 30.52Z",
    fill: "#900037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.533 30.5067L19.1463 19.1334L16.5996 21.2934C16.0663 21.7467 15.373 22 14.6663 22C13.9196 22 13.213 21.7334 12.6663 21.24C12.1196 21.7334 11.413 22 10.6663 22C9.95962 22 9.26629 21.7467 8.71962 21.28L6.29295 19.2267L0.119619 30.52C-0.0537141 30.8267 -0.0403808 31.2 0.132953 31.5067C0.319619 31.8134 0.652953 32 0.999619 32H24.6663C25.0263 32 25.3463 31.8134 25.533 31.5067C25.7063 31.2 25.7063 30.8134 25.533 30.5067Z",
    fill: "#900037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3346 6.66667H12.668C12.116 6.66667 11.668 6.21867 11.668 5.66667V1C11.668 0.448 12.116 0 12.668 0H20.3346C20.7253 0 21.08 0.226667 21.2426 0.582667C21.4066 0.937333 21.348 1.35467 21.0933 1.652L19.652 3.33333L21.0946 5.016C21.3493 5.31333 21.4066 5.73067 21.244 6.08533C21.08 6.44 20.7253 6.66667 20.3346 6.66667Z",
    fill: "#900037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.668 10.6667C12.116 10.6667 11.668 10.2187 11.668 9.66667V1C11.668 0.448 12.116 0 12.668 0C13.22 0 13.668 0.448 13.668 1V9.66667C13.668 10.2187 13.22 10.6667 12.668 10.6667Z",
    fill: "#900037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1476 17.36L15.3076 19.76C15.1209 19.92 14.8942 20 14.6676 20C14.4142 20 14.1609 19.9067 13.9609 19.7067L12.6676 18.4134L11.3742 19.7067C11.0009 20.08 10.4142 20.0934 10.0276 19.76L7.26758 17.44L8.25425 15.6534L11.7876 9.18669C11.9609 8.86669 12.2942 8.66669 12.6676 8.66669C13.0009 8.62669 13.3609 8.85335 13.5342 9.17335L17.1476 15.5867L18.1476 17.36Z",
    fill: "#900037"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_4471"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurMission);
export default __webpack_public_path__ + "static/media/our-mission.2096bb3e2ed03aef31fee79ae24efa7f.svg";
export { ForwardRef as ReactComponent };